import React, { useEffect, useMemo, useRef, useState } from "react";
import PageHeader from "../../components/Header/PageHeader";
import { PageWrapper } from "../../components/Page";
import { Button } from "../../components/Button";
import { ArrowForward, ShoppingCart, ArrowBack } from "@material-ui/icons";
import { TextInput } from "../../components/Input";
import styled from "styled-components";
import { DistributorMenuItem } from "../../components/Distributor";
import { Link, useHistory } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";
import { useDispatch, useSelector } from "react-redux";
import {
  getCart,
  getCartId,
  getDistributors,
  getDistributorsSearched,
  getForm,
  getInstallation,
  getMeasurement,
  getSearchDist,
  getSelectedDistributors,
} from "../../reducers/project/selectors";
import marker from "../../assets/marker/marker.png";
import { ProjectActions } from "../../reducers/project/actionsNames";
import Scrollbars from "react-custom-scrollbars";
import { useFetch } from "../../hooks/useFetch";
import { IProject } from "../../reducers/project";
import content from "../../content";
import { MdSearch } from "react-icons/md";
import { Stepper } from "../../components/Header";
import { PriceExpander } from "../PriceExpander";
import { BsTrashFill } from "react-icons/bs";
import { Mobile, useDesktop } from "../../components/Responsive";

const Marker = ({ children }: any) => children;

const Label = styled.div`
  display: flex;
  align-items: center;
`;

function Map() {
  const mapRef = useRef();
  const [bounds, setBounds] = useState(null);
  const [center, setCenter] = useState({ lat: 52, lng: 19 });
  const [zoom, setZoom] = useState(7);
  const distributors = useSelector(getDistributorsSearched);
  const dispatch = useDispatch();
  const cartId = useSelector(getCartId);
  const cart: IProject[] = useSelector(getCart);

  const [responseUpdate, requestUpdate] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "PUT",
  });

  const points = useMemo(
    () =>
      distributors.map((dist) => ({
        type: "Feature",
        properties: { cluster: false, distId: dist.id },
        geometry: {
          type: "Point",
          coordinates: [dist.lng, dist.lat],
        },
      })),
    [distributors]
  );

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 },
  });

  const select = (id: number) => () => {
    requestUpdate(
      {
        projects: cart,
        step: "Wybor dystrybutora",
      },
      cartId
    );
    dispatch({ type: ProjectActions.SelectDist, id });
  };

  return (
    <div style={{ height: "calc(100% - 125px)" }}>
      <GoogleMapReact
        zoom={zoom}
        options={{
          disableDefaultUI: true,
        }}
        center={center}
        defaultZoom={7}
        yesIWantToUseGoogleMapApiInternals
        defaultCenter={{ lat: 52, lng: 19 }}
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
        }}
        onChange={({ zoom, bounds, center }) => {
          setZoom(zoom);
          setBounds([
            bounds.nw.lng,
            bounds.se.lat,
            bounds.se.lng,
            bounds.nw.lat,
          ] as any);
          setCenter(center);
        }}
      >
        {clusters.map((cluster) => {
          const [longitude, latitude] = cluster.geometry.coordinates;
          const {
            cluster: isCluster,
            point_count: pointCount,
          } = cluster.properties;

          if (isCluster) {
            return (
              <Marker
                key={`cluster-${cluster.id}`}
                lat={latitude}
                lng={longitude}
              >
                <div
                  className="cluster-marker"
                  style={{
                    width: `${10 + (pointCount / points.length) * 20}px`,
                    height: `${10 + (pointCount / points.length) * 20}px`,
                  }}
                  onClick={() => {
                    const expansionZoom = Math.min(
                      supercluster.getClusterExpansionZoom(cluster.id),
                      20
                    );
                    (mapRef as any)?.current?.setZoom(expansionZoom);
                    (mapRef as any)?.current?.panTo({
                      lat: latitude,
                      lng: longitude,
                    });
                  }}
                >
                  {pointCount}
                </div>
              </Marker>
            );
          }

          return (
            <Marker
              key={`dist-${cluster.properties.distId}`}
              lat={latitude}
              lng={longitude}
            >
              <button
                onClick={select(cluster.properties.distId)}
                className="dist-marker"
              >
                <img src={marker} />
              </button>
            </Marker>
          );
        })}
      </GoogleMapReact>
    </div>
  );
}

function OrderDistributor({}: IOrderServices) {
  const search = useSelector(getSearchDist);
  const dispatch = useDispatch();
  const selected = useSelector(getSelectedDistributors);
  const history = useHistory();
  const cartId = useSelector(getCartId);
  const measurement = useSelector(getMeasurement);
  const installation = useSelector(getInstallation);
  const form = useSelector(getForm);

  const [response, request] = useFetch("/order/", {} as any, {
    method: "POST",
  });

  const [responseDist, requestDist] = useFetch("/distributor/");

  useEffect(() => {
    requestDist().then((dist) =>
      dispatch({ type: ProjectActions.LoadDist, dist: dist.distributors })
    );
  }, []);

  const changeSearch = (e) =>
    dispatch({
      type: ProjectActions.SearchDist,
      search: e.currentTarget.value,
    });

  const removeDist = (id: string) => () =>
    dispatch({ type: ProjectActions.RemoveDist, id });

  const sendOrder = () => {
    request({
      cart: cartId,
      measurement: measurement,
      installation: installation,
      ...form,
      distributors: selected.map((s) => s.id),
    }).then((r) => {
        window.localStorage.removeItem("cart");
        dispatch({ type: ProjectActions.RemoveCart });
        history.push("/confirmation", { order: r });
    });
  };

  const desktop = useDesktop();

  return (
    <>
      <PageHeader header={content.getValue("header_step_3")}>
        <Stepper />
      </PageHeader>
      <PageWrapper
        padding={"0px"}
        menu={
          <>
            <div
              style={{
                padding: "24px",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  background: "#F5F4F4",
                  boxSizing: "border-box",
                  padding: "0px 16px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#080808",
                  height: "40px",
                }}
              >
                <Label
                  style={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >
                  {content.getValue("selected_locations")}
                </Label>
              </div>
              <Scrollbars
                style={{
                  border: "1px solid #F5F4F4",
                  boxSizing: "border-box",
                }}
                autoHeight={true}
                autoHeightMin={"592px"}
                autoHeightMax={"592px"}
              >
                {selected.map((s, i) => (
                  <DistributorMenuItem
                    onClick={removeDist(s.id)}
                    count={i + 1}
                    name={s.name}
                    address={s.address}
                  />
                ))}
              </Scrollbars>
            </div>
            <div
              style={{
                marginTop: "auto",
                width: "100%",
                padding: "24px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%" }}>
                  <Link to={"/services"}>
                    <Button
                      variant={"text"}
                      startIcon={
                        <svg
                          width="17"
                          height="8"
                          viewBox="0 0 17 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                            fill="#838282"
                          />
                        </svg>
                      }
                      label={content.getValue("button_back")}
                    />
                  </Link>
                </div>
                <div style={{ width: "50%" }}>
                  <Button
                    onClick={sendOrder}
                    disabled={selected.length === 0}
                    color={"secondary"}
                    variant={"outlined"}
                    Icon={
                      <svg
                        style={{
                          position: "absolute",
                          right: "20px",
                        }}
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                          fill={
                            selected.length === 0
                              ? "rgba(0, 0, 0, 0.26)"
                              : "#C41230"
                          }
                        />
                      </svg>
                    }
                    label={content.getValue("button_send_request")}
                  />
                </div>
              </div>
            </div>
          </>
        }
      >
        <div style={{ width: "100%" }}>
          <p
            style={{
              color: "#666666",
              opacity: 0.6,
              fontSize: "14px",
              width: "70%",
              padding: "24px 32px",
            }}
          >
            {content.getValue("step_3_info")}
          </p>
        </div>
        <TextInput
          margin={"0px"}
          wrapperStyle={{
            position: "absolute",
            width: desktop ? "calc(100% - 580px)" : "80%",
            padding: "24px 40px",
            zIndex: 1000,
          }}
          style={{
            backgroundColor: "#FFFFFF",
            opacity: 1,
            boxShadow: "rgba(0, 0, 0, 0.5) 8px 25px 40px 0px",
            textIndent: "35px",
          }}
          value={search}
          onChange={changeSearch}
          placeholder={content.getValue("step_3_search")}
        />
        <MdSearch
          style={{
            position: "absolute",
            marginTop: "34px",
            marginLeft: "50px",
            zIndex: 1000,
            fontSize: "24px",
            color: "#838282",
            opacity: 0.8,
          }}
        />
        <Map />
        <Mobile>
          <div
            style={{
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                background: "#F5F4F4",
                boxSizing: "border-box",
                padding: "0px 16px",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                color: "#080808",
                height: "40px",
              }}
            >
              <Label
                style={{
                  fontSize: "14px",
                  color: "#080808",
                }}
              >
                {content.getValue("selected_locations")}
              </Label>
            </div>
            <Scrollbars
              style={{
                border: "1px solid #F5F4F4",
                boxSizing: "border-box",
              }}
              autoHeight={true}
              autoHeightMax={"300px"}
            >
              {selected.map((s, i) => (
                <DistributorMenuItem
                  onClick={removeDist(s.id)}
                  count={i + 1}
                  name={s.name}
                  address={s.address}
                />
              ))}
            </Scrollbars>
          </div>
          <div
            style={{
              marginTop: "auto",
              width: "100%",
              padding: "24px",
              boxSizing: "border-box",
            }}
          >
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%" }}>
                <Link to={"/services"}>
                  <Button
                    variant={"text"}
                    startIcon={
                      <svg
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                          fill="#838282"
                        />
                      </svg>
                    }
                    label={content.getValue("button_back")}
                  />
                </Link>
              </div>
              <div style={{ width: "50%" }}>
                <Button
                  onClick={sendOrder}
                  disabled={selected.length === 0}
                  color={"secondary"}
                  variant={"outlined"}
                  Icon={
                    <svg
                      style={{
                        position: "absolute",
                        right: "20px",
                      }}
                      width="17"
                      height="8"
                      viewBox="0 0 17 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                        fill={
                          selected.length === 0
                            ? "rgba(0, 0, 0, 0.26)"
                            : "#C41230"
                        }
                      />
                    </svg>
                  }
                  label={content.getValue("button_send_request")}
                />
              </div>
            </div>
          </div>
        </Mobile>
      </PageWrapper>
    </>
  );
}

export interface IOrderServices {}

export default OrderDistributor;
